import { render, staticRenderFns } from "./AiTab.vue?vue&type=template&id=fc408f8a&scoped=true&"
import script from "./AiTab.vue?vue&type=script&lang=js&"
export * from "./AiTab.vue?vue&type=script&lang=js&"
import style0 from "./AiTab.vue?vue&type=style&index=0&id=fc408f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc408f8a",
  null
  
)

export default component.exports